import React from 'react'

function DeleteSecretData (props) {
          return(
                    <div>
                            <div style={{fontSize:"20px",fontWeight:"normal"}}>
                                <div style={{textAlign:"center"}}>{props.name} ?</div>
                            </div>
                            <div className="text">
                                    <button className="btn"  onClick={()=>props.toggle()}>
                                                No
                                    </button>
                                    <button className="danger-button" onClick={()=>props.deleteSecret()}>
                                                Yes
                                    </button>
                            </div>
                    </div>
          )
}
export default DeleteSecretData